import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { MainCampaignActions } from "../../main-campaign.actions";
import { FormGroup, FormBuilder, FormArray, Validators } from "@angular/forms";
import { GlobalService } from "../../../global.service";
import { mainCampaignServices } from "../../main-campaign.services";
import { ApiService } from "../../../api.service";

@Component({
	selector: 'app-new-line-step-2',
	templateUrl: './new-line-step-2.component.html',
	styleUrls: ['./new-line-step-2.component.scss']
})
export class NewLineStep2Component implements OnInit {

	listBroadband: any;

	listPlans: any;
	listMobilePlans: any;
	listServices: any;
	listDevices: any;
	listColors: any;
	listPlanTypes1: any;
	listPlanTypes2: any;
	listPlanTypes3: any;
	listPlanTypes4: any;
	
	listSupplementaryPlans: any;
	listSupplementaryMobilePlans: any;
	listSupplementaryPlans1: any;
	listSupplementaryPlans2: any;
	listSupplementaryPlans3: any;
	listSupplementaryPlans4: any;
  
	listSupplementaryServices1: any;
	listSupplementaryDevices1: any;
	listSupplementaryColors1: any;
	supplementartyType1:any;
	enableNewLine1:boolean;
	enablePortIn1:boolean;
	enableChangePlan1:boolean;
  
	listSupplementaryServices2: any;
	listSupplementaryDevices2: any;
	listSupplementaryColors2: any;
	supplementartyType2:any;
	enableNewLine2:boolean;
	enablePortIn2:boolean;
	enableChangePlan2:boolean;
  
	listSupplementaryServices3: any;
	listSupplementaryDevices3: any;
	listSupplementaryColors3: any;
	supplementartyType3:any;
	enableNewLine3:boolean;
	enablePortIn3:boolean;
	enableChangePlan3:boolean;
  
	listSupplementaryServices4: any;
	listSupplementaryDevices4: any;
	listSupplementaryColors4: any;
	supplementartyType4:any;
	enableNewLine4:boolean;
	enablePortIn4:boolean;
	enableChangePlan4:boolean;
  
	service: any;
	plan: any;
	device: any;
	color: any;
  
	hasColor: boolean;
  
	numberSupplementaryLine: any;
	numberSupplementaryLineRequire: any;
	listNetwork: any;
  
	supplementaryServices1: any;
	supplementaryPlan1: any;
	supplementaryDevice1: any;
	supplementaryColor1: any;
	supplementaryHasColor1: boolean;
	supplementaryType1:any;
	port_in_from_1:any;
	network1:any;
	change_plan_from_1:any;
	change_plan_currenTypePlan1:any;
	number1:any;
  
	supplementaryServices2: any;
	supplementaryPlan2: any;
	supplementaryDevice2: any;
	supplementaryColor2: any;
	supplementaryHasColor2: boolean;
	supplementaryType2:any;
	port_in_from_2:any;
	network2:any;
	change_plan_from_2:any;
	change_plan_currenTypePlan2:any;
	number2:any;
  
	supplementaryServices3: any;
	supplementaryPlan3: any;
	supplementaryDevice3: any;
	supplementaryColor3: any;
	supplementaryHasColor3: boolean;
	supplementaryType3:any;
	port_in_from_3:any;
	network3:any;
	change_plan_from_3:any;
	change_plan_currenTypePlan3:any;
	number3:any;
  
	supplementaryServices4: any;
	supplementaryPlan4: any;
	supplementaryDevice4: any;
	supplementaryColor4: any;
	supplementaryHasColor4: boolean;
	supplementaryType4:any;
	port_in_from_4:any;
	network4:any;
	change_plan_from_4:any;
	change_plan_currenTypePlan4:any;
	number4:any;

	phoneId1:any;
	phoneId2:any;
	phoneId3:any;
	phoneId4:any;
  
	enableSupplementary1: boolean;
	enableSupplementary2: boolean;
	enableSupplementary3: boolean;
	enableSupplementary4: boolean;

	disableSupplementary1: boolean;
  disableSupplementary2: boolean;
  disableSupplementary3: boolean;
  disableSupplementary4: boolean;
  
	errSupplementary1:string;
	errSupplementary2:string;
	errSupplementary3:string;
	errSupplementary4:string;
  
	successSupplementary1:string;
	successSupplementary2:string;
	successSupplementary3:string;
	successSupplementary4:string;

	enableSupplementaryPortIn     : boolean;
	enableSupplementaryChangePlan : boolean;
	enableSupplementaryNewLine    : boolean;
  
	step2: any = {
	  name: ""
	};
  
  
	defaultType: string;
	defaultNetwork: string;
  
	isSearching: any = false;
	listPhoneNumber: any = [];
	listPhoneNumber_Receive: any = [];
	listPhoneNumber_Receive1: any = [];
	listPhoneNumber_Receive2: any = [];
	listPhoneNumber_Receive3: any = [];
	listPhoneNumber_Receive4: any = [];
	idNumberSelect: number;
	numberSelect: number;
	textSearch: number;
	phoneRequest: number;
	initialData: any;
  
	listPhoneNumberEndReached = true;
  
	form: FormGroup;
  

	constructor(
		private store: Store<any>,
		private globalService: GlobalService,
		private mainCampaignActions: MainCampaignActions,
		private apiService: ApiService,
		private fb: FormBuilder,
		private mainCampaignServices: mainCampaignServices) {
	
		var dataSession = this.globalService.getSession("mainApplication");
		  // console.log(dataSession)
	
		this.listBroadband = dataSession.broad_plan;
	
		this.listPlans = this.globalService.getSession("viewPlan").attributes.plans;
		//sort listPlans
		this.listPlans.sort(function (a, b) {
		  return a.rebate_price - b.rebate_price;
		});
	
		this.listPlanTypes1 = ['New Line','Port In','Change Plan']
		this.listPlanTypes2 = ['New Line','Port In','Change Plan']
		this.listPlanTypes3 = ['New Line','Port In','Change Plan']
		this.listPlanTypes4 = ['New Line','Port In','Change Plan']
	
		this.defaultType = "New Line";
		this.getNetwork();
		this.defaultNetwork = 'Maxis';
	
		this.numberSupplementaryLine = this.globalService.getSession("viewPlan").attributes.number_supplementary_line;    
		this.numberSupplementaryLineRequire = this.globalService.getSession("viewPlan").attributes.number_supplementary_line_require;    

		this.enableSupplementary1 = dataSession.enableSupplementary1;
		this.enableSupplementary2 = dataSession.enableSupplementary2;
		this.enableSupplementary3 = dataSession.enableSupplementary3;
		this.enableSupplementary4 = dataSession.enableSupplementary4;
  
		this.disableSupplementary1 = false;
		this.disableSupplementary2 = false;
		this.disableSupplementary3 = false;
		this.disableSupplementary4 = false;
  
	  if(this.numberSupplementaryLineRequire > 0){
		this.enableSupplementary1 = true;
		this.disableSupplementary1 = true;
	  }
	  if(this.numberSupplementaryLineRequire > 1){
		this.enableSupplementary2 = true;
		this.disableSupplementary2 = true;      
	  }
	  if(this.numberSupplementaryLineRequire > 2){
		this.enableSupplementary3 = true;
		this.disableSupplementary3 = true;
	  }
	  if(this.numberSupplementaryLineRequire > 3){
		this.enableSupplementary4 = true;
		this.disableSupplementary3 = true;
	  }
  
		//   console.log(this.enableSupplementary2)
		this.listPlans = this.listPlans.map(element => {
		  var cleanText = element.plan_title.replace(/<\/?[^>]+(>|$)/g, "").replace(/&nbsp;/gi,'').replace(/\s\s+/g, ' ').trim();
		  return Object.assign({}, element, {
			title: cleanText
		  })
		});

		this.listMobilePlans = [];
		this.listPlans.forEach( (plan , _index) => {		
				// 1, // primary mobile
				// 2, // supplementary mobile
				// 3, // primary broadband
				// 4  // supplementary broadband			
				if(plan.plan_category == 1 || plan.plan_category == 2 ){			  
					this.listMobilePlans.push(plan);
				}
		});	

		
		// @tam apply rule broadband plan only choose option = new line
		if(dataSession.option == 'changePlan' ||dataSession.option == 'portIn'){
		this.listPlans = this.listMobilePlans;
		// remove broadband plan
		}
	
		this.listPlans.forEach(i => {
		  if (i.id == dataSession.planId) {
			this.listServices = i.services.map(j => {
			  return {
				selected: false,
				value: j
			  }
			});
		  }
	
		});
		this.plan = this.listPlans[0];
	
		this.listPlans.forEach(plan => {
		  if(plan.id == dataSession.planId){
			this.plan = plan;
		  }
		});
	
	
		this.listSupplementaryPlans = this.globalService.getSession("viewPlan").attributes.supplementary_plans;
		//sort listPlans
		this.listSupplementaryPlans.sort(function (a, b) {
		  return a.rebate_price - b.rebate_price;
		});
	
		this.listSupplementaryPlans = this.listSupplementaryPlans.map(element => {
		  var cleanText = element.plan_title.replace(/<\/?[^>]+(>|$)/g, "").replace(/&nbsp;/gi,'').replace(/\s\s+/g, ' ').trim();
		  return Object.assign({}, element, {
			title: cleanText
		  })
		});
				
		this.listSupplementaryMobilePlans = [];
		this.listSupplementaryPlans.forEach( (plan , _index) => {		
			// 1, // primary mobile
			// 2, // supplementary mobile
			// 3, // primary broadband
			// 4  // supplementary broadband			
			if(plan.plan_category == 1 || plan.plan_category == 2 ){			  
				this.listSupplementaryMobilePlans.push(plan);
			}
		});	

		this.enableSupplementaryPortIn     = true;
		this.enableSupplementaryChangePlan = true;
		this.enableSupplementaryNewLine    = true;
		if(this.listSupplementaryMobilePlans.length == 0){
			this.enableSupplementaryPortIn     = false;
			this.enableSupplementaryChangePlan = false;
		}	

		if(dataSession.step2){
		  this.listPlans.forEach( (plan , index) => {
			if(plan.id == dataSession.step2.plan.id){
			  this.plan = plan;
			}
		  });
	
		  this.listDevices = this.plan.devices;
		  //sort listDevices
		  this.listDevices.sort(function (a, b) {
			return a.device_rrp_final - b.device_rrp_final;
		  });
		  this.listDevices.forEach(device => {
			if(device.id == dataSession.step2.device.id){
			  this.device = device;
			  if(Array.isArray(this.device.colors)){
				this.device.colors.forEach(color => {
				  if(color.id == dataSession.step2.color.id){
					this.color = color;
				  }
				});
				this.listColors = this.device.colors;
				this.hasColor = this.listColors.length > 0;
			  }
			  else{
				this.hasColor = false;
			  }
			}        
		  });
		  (!this.device) ? this.device = "" : "";
	
		  this.listServices = dataSession.step2.services;
		  this.listBroadband = dataSession.step2.broad_plan;
		  // this.onChangePlan(true);
			 
		}else{
		  this.listDevices = this.plan.devices;
		  //sort listDevices
		  this.listDevices.sort(function (a, b) {
			return a.device_rrp_final - b.device_rrp_final;
		  });
		  this.device = this.listDevices[0] || "";
		  if(Array.isArray(this.device.colors)){
			this.color = this.device.colors[0] || "";
			this.listColors = this.device.colors;
			this.hasColor = this.listColors.length > 0;
		  }else{
			this.hasColor = false;
		  }
		  // this.onChangePlan(false);			  
		}
		
		this.initSupplementaryPlan(1);
		this.initSupplementaryPlan(2);
		this.initSupplementaryPlan(3);
		this.initSupplementaryPlan(4);
	}

	initSupplementaryPlan(index){
		this["listSupplementaryPlans"+index] = this.listSupplementaryPlans;
		
		var dataSession = this.globalService.getSession("mainApplication");
		this["listSupplementaryPlans"+index].forEach(i => {
		  if (i.id == dataSession["supplementaryPlanId"+index]) {
			this["listSupplementaryServices"+index] = i.services.map(j => {
			  return {
				selected: false,
				value: j
			  }
			});
		  }
		});
		
		this["supplementaryPlan"+index] = this["listSupplementaryPlans"+index][0];
		
		this["listSupplementaryPlans"+index].forEach(plan => {
		  if(plan.id == dataSession["supplementaryPlanId"+index]){
			this["supplementaryPlan"+index] = plan;
		  }
		});		
	
	
		if(dataSession.step2){		  
		  	if(this["listSupplementaryPlans"+index].length > 0 ){
				this["listSupplementaryPlans"+index].forEach( (plan , _index) => {
					var curSupplementaryPlanID = 0;
					eval("curSupplementaryPlanID = dataSession.step2.supplementaryPlan"+index+".id");
					if(plan.id == curSupplementaryPlanID){
						this["supplementaryPlan"+index] = plan;
					}				  
				});
		
			
				this["listSupplementaryDevices"+index] = this["supplementaryPlan"+index].devices;
				
				//sort listDevices
				this["listSupplementaryDevices"+index].sort(function (a, b) {
				return a.device_rrp_final - b.device_rrp_final;
				});	
		
				this["listSupplementaryDevices"+index].forEach(device => {
					var curSupplementaryDeviceID = 0;
					eval("curSupplementaryDeviceID = dataSession.step2.supplementaryDevice"+index+".id");
					if(device.id == curSupplementaryDeviceID){
						this["supplementaryDevice"+index] = device;
						if(Array.isArray(this["supplementaryDevice"+index].colors)){
							var curSupplementaryColorID = 0;
							eval("curSupplementaryColorID = dataSession.step2.supplementaryColor"+index+".id");
							this["supplementaryDevice"+index].colors.forEach(color => {
								if(color.id == curSupplementaryColorID){
								this["supplementaryColor"+index] = color;
								}
							});
							this["listSupplementaryColors"+index] = this["supplementaryDevice"+index].colors;
							this["supplementaryHasColor"+index] = this["listSupplementaryColors"+index].length > 0;
						}
						else{
						this["supplementaryHasColor"+index] = false;
						}
					}        
				});
				(!this["supplementaryDevice"+index]) ? this["supplementaryDevice"+index] = "" : "";
				var curSupplementaryServices = false;
				eval("curSupplementaryServices = dataSession.step2.supplementaryServices"+index);
				this["listSupplementaryServices"+index] = curSupplementaryServices;									
			}		
		}else{
		  
		  	if(this["listSupplementaryPlans"+index].length > 0 ){
				this["listSupplementaryDevices"+index] = this["supplementaryPlan"+index].devices;
				//sort listDevices
				this["listSupplementaryDevices"+index].sort(function (a, b) {
					return a.device_rrp_final - b.device_rrp_final;
				});
				this["supplementaryDevice"+index] = this["listSupplementaryDevices"+index][0] || "";
				
				if(Array.isArray(this["supplementaryDevice"+index].colors)){
					this["supplementaryColor"+index] = this["supplementaryDevice"+index].colors[0] || "";
					this["listSupplementaryColors"+index] = this["supplementaryDevice"+index].colors;
					this["supplementaryHasColor"+index] = this["listSupplementaryColors"+index].length > 0;
				}else{
				this["supplementaryHasColor"+index] = false;
				}
		  	}			  
		}
	}

	table_status :false;
	toggle_broadbrand(item:any){
		if(item.status == true  ){
		item.status = false
		}else{
		item.status = true
		}
	  
	}


	changeCheckboxServices(i) {
		if (this.listServices[i]) {
			this.listServices[i].selected = !this.listServices[i].selected;
		}
	}
	changeCheckboxBroadband(i) {
		this.listBroadband.forEach(e => {
			e.selected = false;
		});
		if (this.listBroadband[i]) {
			this.listBroadband[i].selected = !this.listBroadband[i].selected;
		}

	}

	ngOnInit() {

	}
	

	// check validate
	onValidateCheckbox() {
		let hasService = false;
		this.listServices.forEach(element => {
			if (element.selected) {
				hasService = true;
			}
		});
		return hasService;
	}

	// change device plan
	onChangePlan(item) {

		// devices
		this.listServices = item.services.map(service => {
			return {
				selected: false,
				value: service
			}
		});
		this.listDevices = item.devices;
		if (this.listDevices) {
			this.device = this.listDevices[0] || "";
			if(Array.isArray(this.device.colors)){
				this.color = this.device.colors[0] || "";
				this.listColors = this.device.colors;
				this.hasColor = this.listColors.length > 0;
			  }else{
				this.hasColor = false;
			  }
		}

		// broadband

		//data request to get Broadbrand
		let dataRequestBroadbrand = {
			campaign_Id: parseInt(this.globalService.getSession("id_campaign")),
			plan_Id: item.id
		}
		this.apiService.getBroadbrand(dataRequestBroadbrand).subscribe(res => {
			if (res.success) {
				this.listBroadband = res.data.broad_plan.original.data.collection;
				this.listBroadband.forEach(e => {
					e.selected = false
				});
			}
		})


	}

	onChangePlanType(item, index) {
    
		var oldType = this["supplementartyType"+index];
		if (index == 1 || index == 2 || index == 3 || index == 4){
		   eval("this.supplementartyType"+index+"=\""+item+"\";");
		} 
		
		
		if(item == "New Line" || item == "Port In" || item == "Change Plan"){   
		  eval("this.enableNewLine"+index+"=false;");
		  eval("this.enablePortIn"+index+"=false;");
		  eval("this.enableChangePlan"+index+"=false;");
		  // this.defaultType = item;
		  if(item == "New Line"){
			eval("this.enableNewLine"+index+"=true;");    
			// auto load number
	
			let searchType = this["supplementaryPlan"+index].plan_category;   
			this.getListPhone('', searchType, index, true);
		  }
		  if(item == "Port In"){
			eval("this.enablePortIn"+index+"=true;");              
		  }
		  if(item == "Change Plan"){
			eval("this.enableChangePlan"+index+"=true;");
		  }
		}    
	
		if(oldType == "New Line" && this['phoneId'+index] != undefined){
		  var requestUpdateStatusPhoneNumberRollback = {
			number_id: this['phoneId'+index],
			status: 2
		  };
		  this.mainCampaignServices.updateStatusPhoneNumberRollback(requestUpdateStatusPhoneNumberRollback).subscribe(res => {
			  // console.log('res on phoneOnSession', res);
			  this.reloadPhoneList(index);
		  });
		}

		this.reloadSupplementaryPlan(index);
	}

	reloadSupplementaryPlan(index){
		var supplementaryType = this["supplementartyType"+index];
		if(supplementaryType == "New Line" || supplementaryType == "Port In" || supplementaryType == "Change Plan"){   
			if(supplementaryType == "New Line"){
				this["listSupplementaryPlans"+index] = this.listSupplementaryPlans;				
			}
			if(supplementaryType == "Port In"){
			  // remove Broadband : 3 & 4
			  this["listSupplementaryPlans"+index] = this.listSupplementaryMobilePlans;
			}
			if(supplementaryType == "Change Plan"){
			  // remove Broadband :  : 3 & 4
			  this["listSupplementaryPlans"+index] = this.listSupplementaryMobilePlans;
			}

			var firstSupplementary = this["listSupplementaryPlans"+index][0];
			this["supplementaryPlan"+index] = firstSupplementary;
			eval("this.onChangeSupplementaryPlan"+index+"(firstSupplementary)");
		}
	}

	
	onDeviceChange(item) {
		// console.log(this.device);
		 // devices
		this.listColors = item.colors;
		if (this.listColors) {
		  this.color = this.listColors[0] || "";
		  this.hasColor = this.listColors.length > 0;
		}else{
			this.hasColor = false;
		}
	  }
	
	  onDeviceColorChange(item) {
		// console.log(this.device);
		 // devices
		this.color = item;
	  }

	// next
	onClickNext() {

		this.errSupplementary1 = "";
		this.errSupplementary2 = "";
		this.errSupplementary3 = "";
		this.errSupplementary4 = "";

    
		var statusSupplementary1 = false;
		var statusSupplementary2 = false;
		var statusSupplementary3 = false;
		var statusSupplementary4 = false;

		var confirmMessage = "Would you like to confirm your supplementary plan subscription details?";

		if(this.enableSupplementary1){
			statusSupplementary1 = this.checkSaveSupplementaryPlan(1);
			if(!statusSupplementary1) confirmMessage += "\n Supplementary line 1 "; 
		}
		if(this.enableSupplementary2){
			statusSupplementary2 = this.checkSaveSupplementaryPlan(2);
			if(!statusSupplementary2) confirmMessage += "\n Supplementary line 2 ";
		}
		if(this.enableSupplementary3){
			statusSupplementary3 = this.checkSaveSupplementaryPlan(3);
			if(!statusSupplementary3) confirmMessage += "\n Supplementary line 3 ";
		}
		if(this.enableSupplementary4){
			statusSupplementary4 = this.checkSaveSupplementaryPlan(4);
			if(!statusSupplementary4) confirmMessage += "\n Supplementary line 4 ";
		}
		if(statusSupplementary1 || statusSupplementary2 || statusSupplementary3 || statusSupplementary4){
			var confirmStatus = confirm(confirmMessage);
			if(!confirmStatus){
				console.log("reject")
				return;
			}
		}

		if(this.enableSupplementary1){
			this.saveSupplementaryPlan(1, false);
		}
		if(this.enableSupplementary2){
			this.saveSupplementaryPlan(2, false);
		}
		if(this.enableSupplementary3){
			this.saveSupplementaryPlan(3, false);
		}
		if(this.enableSupplementary4){
			this.saveSupplementaryPlan(4, false);
		}

		if(this.enableSupplementary1){
			this.saveSupplementaryPlan(1, false);
		}
		if(this.enableSupplementary2){
			this.saveSupplementaryPlan(2, false);
		}
		if(this.enableSupplementary3){
			this.saveSupplementaryPlan(3, false);
		}
		if(this.enableSupplementary4){
			this.saveSupplementaryPlan(4, false);
		}

		if(this.enableSupplementary1){
			var _status = true;
			var _supplementaryplanType          = this.supplementartyType1;
			var _supplementaryPlan              = this.supplementaryPlan1;
			var _supplementaryDevice            = this.supplementaryDevice1;
			var _supplementaryNumber            = this.number1;
			var _supplementaryPortInFrom        = this.port_in_from_1;
			var _supplementaryCurrentNetwork    = this.network1;
			var _supplementaryChangePlanFrom    = this.change_plan_from_1;
			var _supplementaryCurrentPlanType   = this.change_plan_currenTypePlan1;
			var _supplementaryDeviceLength 		= this.supplementaryPlan1.devices.length;

			if(_supplementaryplanType != "New Line" && _supplementaryplanType != "Port In" && _supplementaryplanType != "Change Plan"){ 
				_status = false;
			}
			
			if(_supplementaryplanType == "New Line"){ 
				
			}

			if(_supplementaryplanType == "Port In"){ 
				if(!_supplementaryPortInFrom) {
				_status = false;
				}      
				if(!_supplementaryCurrentNetwork) {
				_status = false;
				}              
			}

			if(_supplementaryplanType == "Change Plan"){ 
				if(!_supplementaryChangePlanFrom) {
				_status = false;
				}      
				if(!_supplementaryCurrentPlanType) {
				_status = false;
				} 
			}

			if(!isNaN(_supplementaryPlan)){
				_status = false;
			}

			if(_supplementaryDeviceLength > 0){
				if(!_supplementaryDevice) {      
					_status = false;          
				}else{
					if(isNaN(_supplementaryDevice.id)){        
					_status = false;
					}
				}
			}
			
			if(isNaN(_supplementaryNumber)){
				_status = false;
			}
			if(!_status){
				this.errSupplementary1 = "Please input all require data for suppplementary plan";
				return;
			}
		}

		if(this.enableSupplementary2){
			var _status = true;
			var _supplementaryplanType          = this.supplementartyType2;
			var _supplementaryPlan              = this.supplementaryPlan2;
			var _supplementaryDevice            = this.supplementaryDevice2;
			var _supplementaryNumber            = this.number2;
			var _supplementaryPortInFrom        = this.port_in_from_2;
			var _supplementaryCurrentNetwork    = this.network2;
			var _supplementaryChangePlanFrom    = this.change_plan_from_2;
			var _supplementaryCurrentPlanType   = this.change_plan_currenTypePlan2;
			var _supplementaryDeviceLength 		= this.supplementaryPlan2.devices.length;

			if(_supplementaryplanType != "New Line" && _supplementaryplanType != "Port In" && _supplementaryplanType != "Change Plan"){ 
				_status = false;
			}
			
			if(_supplementaryplanType == "New Line"){ 
				
			}

			if(_supplementaryplanType == "Port In"){ 
				if(!_supplementaryPortInFrom) {
				_status = false;
				}      
				if(!_supplementaryCurrentNetwork) {
				_status = false;
				}              
			}

			if(_supplementaryplanType == "Change Plan"){ 
				if(!_supplementaryChangePlanFrom) {
				_status = false;
				}      
				if(!_supplementaryCurrentPlanType) {
				_status = false;
				} 
			}

			if(!isNaN(_supplementaryPlan)){
				_status = false;
			}

			if(_supplementaryDeviceLength > 0){
				if(!_supplementaryDevice) {      
					_status = false;          
				}else{
					if(isNaN(_supplementaryDevice.id)){        
					_status = false;
					}
				}
			}
			
			if(isNaN(_supplementaryNumber)){
				_status = false;
			}
			if(!_status){
				this.errSupplementary2 = "Please input all require data for suppplementary plan";
				return;
			}
		}

		if(this.enableSupplementary3){
			var _status = true;
			var _supplementaryplanType          = this.supplementartyType3;
			var _supplementaryPlan              = this.supplementaryPlan3;
			var _supplementaryDevice            = this.supplementaryDevice3;
			var _supplementaryNumber            = this.number3;
			var _supplementaryPortInFrom        = this.port_in_from_3;
			var _supplementaryCurrentNetwork    = this.network3;
			var _supplementaryChangePlanFrom    = this.change_plan_from_3;
			var _supplementaryCurrentPlanType   = this.change_plan_currenTypePlan3;
			var _supplementaryDeviceLength 		= this.supplementaryPlan3.devices.length;

			if(_supplementaryplanType != "New Line" && _supplementaryplanType != "Port In" && _supplementaryplanType != "Change Plan"){ 
				_status = false;
			}
			
			if(_supplementaryplanType == "New Line"){ 
				
			}

			if(_supplementaryplanType == "Port In"){ 
				if(!_supplementaryPortInFrom) {
				_status = false;
				}      
				if(!_supplementaryCurrentNetwork) {
				_status = false;
				}              
			}

			if(_supplementaryplanType == "Change Plan"){ 
				if(!_supplementaryChangePlanFrom) {
				_status = false;
				}      
				if(!_supplementaryCurrentPlanType) {
				_status = false;
				} 
			}

			if(!isNaN(_supplementaryPlan)){
				_status = false;
			}

			if(_supplementaryDeviceLength > 0){
				if(!_supplementaryDevice) {      
					_status = false;          
				}else{
					if(isNaN(_supplementaryDevice.id)){        
					_status = false;
					}
				}
			}
			
			if(isNaN(_supplementaryNumber)){
				_status = false;
			}
			if(!_status){
				this.errSupplementary3 = "Please input all require data for suppplementary plan";
				return;
			}
		}

		if(this.enableSupplementary4){
			var _status = true;
			var _supplementaryplanType          = this.supplementartyType4;
			var _supplementaryPlan              = this.supplementaryPlan4;
			var _supplementaryDevice            = this.supplementaryDevice4;
			var _supplementaryNumber            = this.number4;
			var _supplementaryPortInFrom        = this.port_in_from_4;
			var _supplementaryCurrentNetwork    = this.network4;
			var _supplementaryChangePlanFrom    = this.change_plan_from_4;
			var _supplementaryCurrentPlanType   = this.change_plan_currenTypePlan4;
			var _supplementaryDeviceLength 		= this.supplementaryPlan4.devices.length;

			if(_supplementaryplanType != "New Line" && _supplementaryplanType != "Port In" && _supplementaryplanType != "Change Plan"){ 
				_status = false;
			}
			
			if(_supplementaryplanType == "New Line"){ 
				
			}

			if(_supplementaryplanType == "Port In"){ 
				if(!_supplementaryPortInFrom) {
				_status = false;
				}      
				if(!_supplementaryCurrentNetwork) {
				_status = false;
				}              
			}

			if(_supplementaryplanType == "Change Plan"){ 
				if(!_supplementaryChangePlanFrom) {
				_status = false;
				}      
				if(!_supplementaryCurrentPlanType) {
				_status = false;
				} 
			}

			if(!isNaN(_supplementaryPlan)){
				_status = false;
			}

			if(_supplementaryDeviceLength > 0){
				if(!_supplementaryDevice) {      
					_status = false;          
				}else{
					if(isNaN(_supplementaryDevice.id)){        
					_status = false;
					}
				}
			}
			
			if(isNaN(_supplementaryNumber)){
				_status = false;
			}
			if(!_status){
				this.errSupplementary4 = "Please input all require data for suppplementary plan";
				return;
			}
		}

		//save session
		let newValue = {
			services: this.listServices,
			plan: this.plan,
			device: this.device,
			color: this.color,
			broad_plan: this.listBroadband,

			enableSupplementary1: this.enableSupplementary1,
			enableSupplementary2: this.enableSupplementary2,
			enableSupplementary3: this.enableSupplementary3,
			enableSupplementary4: this.enableSupplementary4,
	  
			supplementaryServices1: this.supplementaryServices1,
			supplementaryServices2: this.supplementaryServices2,
			supplementaryServices3: this.supplementaryServices3,
			supplementaryServices4: this.supplementaryServices4,
	  
			supplementaryPlan1: this.supplementaryPlan1,
			supplementaryDevice1: this.supplementaryDevice1,
			supplementaryColor1: this.supplementaryColor1,
			supplementaryType1: this.supplementaryType1,          
			port_in_from_1:this.port_in_from_1,     
			network1:this.network1,     
			change_plan_from_1:this.change_plan_from_1,     
			change_plan_currenTypePlan1:this.change_plan_currenTypePlan1,     
			number1:this.number1,     
			phoneId1:this.phoneId1,  
	  
	  
			supplementaryPlan2: this.supplementaryPlan2,
			supplementaryDevice2: this.supplementaryDevice2,
			supplementaryColor2: this.supplementaryColor2,
			supplementaryType2: this.supplementaryType2,
			port_in_from_2:this.port_in_from_2,     
			network2:this.network2,     
			change_plan_from_2:this.change_plan_from_2,     
			change_plan_currenTypePlan2:this.change_plan_currenTypePlan2,     
			number2:this.number2,   
			phoneId2:this.phoneId2,  
	  
			supplementaryPlan3: this.supplementaryPlan3,
			supplementaryDevice3: this.supplementaryDevice3,
			supplementaryColor3: this.supplementaryColor3,
			supplementaryType3: this.supplementaryType3,
			port_in_from_3:this.port_in_from_3,     
			network3:this.network3,     
			change_plan_from_3:this.change_plan_from_3,     
			change_plan_currenTypePlan3:this.change_plan_currenTypePlan3,     
			number3:this.number3,   
			phoneId3:this.phoneId3,  
	  
			supplementaryPlan4: this.supplementaryPlan4,
			supplementaryDevice4: this.supplementaryDevice4,
			supplementaryColor4: this.supplementaryColor4,
			supplementaryType4: this.supplementaryType4,
			port_in_from_4:this.port_in_from_4,     
			network4:this.network4,     
			change_plan_from_4:this.change_plan_from_4,     
			change_plan_currenTypePlan4:this.change_plan_currenTypePlan4,     
			number4:this.number4,   
			phoneId4:this.phoneId4,  
		}

		// console.log(newValue);
		let newValueSession = {
			step2: Object.assign({}, newValue),
			planId:this.plan.id,
			deviceId : this.device.id,
			supplementaryPlanId1: this.enableSupplementary1 ? this.supplementaryPlan1.id : false,
			supplementaryPlanId2: this.enableSupplementary2 ? this.supplementaryPlan2.id : false,
			supplementaryPlanId3: this.enableSupplementary3 ? this.supplementaryPlan3.id : false,
			supplementaryPlanId4: this.enableSupplementary4 ? this.supplementaryPlan4.id : false,
	  
			enableSupplementary1: this.enableSupplementary1,
			enableSupplementary2: this.enableSupplementary2,
			enableSupplementary3: this.enableSupplementary3,
			enableSupplementary4: this.enableSupplementary4,
	  
		};
		newValueSession = Object.assign({}, this.globalService.getSession("mainApplication"), newValueSession);
		this.globalService.setSession("mainApplication", newValueSession);

		// console.log(newValueSession);
		//next
		this.store.dispatch(this.mainCampaignActions.updateStep2({}))
	}


	onClickPrev() {
		this.store.dispatch(this.mainCampaignActions.stepPrev());
	}

	onChangeSupplementaryPlan1(item) {
		// devices
		this.listSupplementaryServices1 = item.services.map(service => {
			return {
				selected: false,
				value: service
			}
		});
		this.listSupplementaryDevices1 = item.devices;
		if (this.listSupplementaryDevices1) {
			this.supplementaryDevice1 = this.listSupplementaryDevices1[0] || "";
			if(Array.isArray(this.supplementaryDevice1.colors)){
				this.supplementaryColor1 = this.supplementaryDevice1.colors[0] || "";
				this.listSupplementaryColors1 = this.supplementaryDevice1.colors;
				this.supplementaryHasColor1 = this.listSupplementaryColors1.length > 0;
			  }else{
				this.supplementaryHasColor1 = false;
			  }
		}	
		
		if(this.enableNewLine1){
			// auto load number
			let searchType = this.supplementaryPlan1.plan_category;    
			this.getListPhone('', searchType, 1, true);
		  }
	}

  onChangeSupplementaryPlan2(item) {

		// devices
		this.listSupplementaryServices2 = item.services.map(service => {
			return {
				selected: false,
				value: service
			}
		});
		this.listSupplementaryDevices2 = item.devices;
		if (this.listSupplementaryDevices2) {
			this.supplementaryDevice2 = this.listSupplementaryDevices2[0] || "";
			if(Array.isArray(this.supplementaryDevice2.colors)){
				this.supplementaryColor2 = this.supplementaryDevice2.colors[0] || "";
				this.listSupplementaryColors2 = this.supplementaryDevice2.colors;
				this.supplementaryHasColor2 = this.listSupplementaryColors2.length > 0;
			  }else{
				this.supplementaryHasColor2 = false;
			  }
		}		
		if(this.enableNewLine2){
			// auto load number
			let searchType = this.supplementaryPlan2.plan_category;    
			this.getListPhone('', searchType, 2, true);
		  }
	}

  onChangeSupplementaryPlan3(item) {

		// devices
		this.listSupplementaryServices3 = item.services.map(service => {
			return {
				selected: false,
				value: service
			}
		});
		this.listSupplementaryDevices3 = item.devices;
		if (this.listSupplementaryDevices3) {
			this.supplementaryDevice3 = this.listSupplementaryDevices3[0] || "";
			if(Array.isArray(this.supplementaryDevice3.colors)){
				this.supplementaryColor3 = this.supplementaryDevice3.colors[0] || "";
				this.listSupplementaryColors3 = this.supplementaryDevice3.colors;
				this.supplementaryHasColor3 = this.listSupplementaryColors3.length > 0;
			  }else{
				this.supplementaryHasColor3 = false;
			  }
		}		
		if(this.enableNewLine3){
			// auto load number
			let searchType = this.supplementaryPlan3.plan_category;    
			this.getListPhone('', searchType, 3, true);
		  }
	}

  onChangeSupplementaryPlan4(item) {

		// devices
		this.listSupplementaryServices4 = item.services.map(service => {
			return {
				selected: false,
				value: service
			}
		});
		this.listSupplementaryDevices4 = item.devices;
		if (this.listSupplementaryDevices4) {
			this.supplementaryDevice4 = this.listSupplementaryDevices4[0] || "";
			if(Array.isArray(this.supplementaryDevice4.colors)){
				this.supplementaryColor4 = this.supplementaryDevice4.colors[0] || "";
				this.listSupplementaryColors4 = this.supplementaryDevice4.colors;
				this.supplementaryHasColor4 = this.listSupplementaryColors4.length > 0;
			  }else{
				this.supplementaryHasColor4 = false;
			  }
		}		
		if(this.enableNewLine4){
			// auto load number
			let searchType = this.supplementaryPlan4.plan_category;    
			this.getListPhone('', searchType, 4, true);
		  }
	}

  onSupplementaryDeviceChange1(item) {
    // devices
    if(!item || !Array.isArray(item.colors))return;
    this.listSupplementaryColors1 = item.colors;
    if (this.listSupplementaryColors1) {
      this.supplementaryColor1 = this.listSupplementaryColors1[0] || "";
      this.supplementaryHasColor1 = this.listSupplementaryColors1.length > 0;
    }else{
      this.supplementaryHasColor1 = false;
    }
  }

  onSupplementaryDeviceChange2(item) {
    // devices
    if(!item || !Array.isArray(item.colors))return;
    this.listSupplementaryColors2 = item.colors;
    if (this.listSupplementaryColors2) {
      this.supplementaryColor2 = this.listSupplementaryColors2[0] || "";
      this.supplementaryHasColor2 = this.listSupplementaryColors2.length > 0;
    }else{
      this.supplementaryHasColor2 = false;
    }
  }

  onSupplementaryDeviceChange3(item) {
    // devices
    if(!item || !Array.isArray(item.colors))return;
    this.listSupplementaryColors3 = item.colors;
    if (this.listSupplementaryColors3) {
      this.supplementaryColor3 = this.listSupplementaryColors3[0] || "";
      this.supplementaryHasColor3 = this.listSupplementaryColors3.length > 0;
    }else{
      this.supplementaryHasColor3 = false;
    }
  }

  onSupplementaryDeviceChange4(item) {
    // devices
    if(!item || !Array.isArray(item.colors))return;
    this.listSupplementaryColors4 = item.colors;
    if (this.listSupplementaryColors4) {
      this.supplementaryColor4 = this.listSupplementaryColors4[0] || "";
      this.supplementaryHasColor4 = this.listSupplementaryColors4.length > 0;
    }else{
      this.supplementaryHasColor4 = false;
    }
  }

  saveSupplementaryPlan(index, mustConfirm = true){
	// $("[name='port_in_from_1']").val(1);
   if(mustConfirm == true){
		   
	 var statusCheckSupplementary = this.checkSaveSupplementaryPlan(index);
	 if(statusCheckSupplementary){
	   var confirmMessage = "Would you like to confirm your supplementary plan "+index+" subscription details?";     
	   var confirmStatus = confirm(confirmMessage);
	   if(!confirmStatus){
		 console.log("reject")
		 return;
	   }
	 }
   }

     // $("[name='port_in_from_1']").val(1);
	 var errorMsg = "";
	 var successMsg = "The supplementary is added success!!";
	 var currentType = $("[name='planType"+index+"']:checked").val();    
	 var supplementary_plan = $("[name='supplementary_plan"+index+"']").val(); 
	 var supplementary_device = $("[name='supplementary_device"+index+"']").val(); 
	 var supplementary_device_length = this['supplementaryPlan'+index].devices.length;
	 eval("this.errSupplementary"+index+" = \"\";");        
 
	 if(currentType == "New Line"){
	   var phoneNumber =  $("[name='new_line_phone_number"+index+"']").val();      
 
	   if(phoneNumber === undefined || phoneNumber == ""){
		 errorMsg += "Please choose the phone number<br/>";        
	   }
	   
	   if(supplementary_plan === undefined || supplementary_plan == ""){
		 errorMsg += "Please choose the supplementary plan<br/>";        
	   }
 
	   if(supplementary_device_length >  0 && (supplementary_device === undefined || supplementary_device == "")){
		 errorMsg += "Please choose the supplementary device<br/>";        
	   }
 
	   if(errorMsg === ""){
		 eval("this.supplementaryType"+index+" = \"New Line\";");
		 eval("this.successSupplementary"+index+" = successMsg;");        
		 eval("this.errSupplementary"+index+" = \"\";");      
 
		 if(phoneNumber != this["phoneId"+index] && this["number"+index] == undefined){			
			eval("this.number"+index+" = phoneNumber;"); 
		}    
				 
	   }else{        
		 eval("this.errSupplementary"+index+" = errorMsg;");                
		 eval("this.successSupplementary"+index+" = \"\";");       
		 eval("this.supplementaryType"+index+" = \"\";");                                     
	   }    
 
	   return;
	 }
	 if(currentType == "Port In"){
	   var network = $("[name='port_in_network"+index+"']").val();
	   var port_in_from = $("[name='port_in_from_"+index+"']").val();
	   var phoneNumber =  $("[name='port_in_phone_number"+index+"']").val();      
 
	   if(port_in_from === undefined || port_in_from == ""){
		 errorMsg += "Please choose port in for<br/>";        
	   }
	   
	   if(network === undefined || network == ""){
		 errorMsg += "Please choose current telco<br/>";        
	   }
 
	   if(phoneNumber === undefined || phoneNumber == ""){
		 errorMsg += "Please input the phone number";        
	   }
 
	   if(supplementary_plan === undefined || supplementary_plan == ""){
		 errorMsg += "Please choose the supplementary plan<br/>";        
	   }
 
	   if(supplementary_device_length >  0 && (supplementary_device === undefined || supplementary_device == "")){
		 errorMsg += "Please choose the supplementary device<br/>";        
	   }
 
	   if(errorMsg === ""){
		 eval("this.supplementaryType"+index+" = \"Port In\";");
		 eval("this.successSupplementary"+index+" = successMsg;");     
		 eval("this.errSupplementary"+index+" = \"\";");         
		 
		 
		 eval("this.port_in_from_"+index+" = port_in_from;");     
		 eval("this.network"+index+" = network;");     
		 eval("this.number"+index+" = phoneNumber;");    
 
	   }else{
		 eval("this.errSupplementary"+index+" = errorMsg;"); 
		 eval("this.successSupplementary"+index+" = \"\";"); 
		 eval("this.supplementaryType"+index+" = \"\";");                            
	   }    
	   return;
	 }
	 if(currentType == "Change Plan"){
	   var change_plan_from = $("[name='change_plan_change_plan_from_"+index+"']").val();
	   var currentPlan = $("[name='change_plan_currenTypePlan"+index+"']").val();
	   var phoneNumber =  $("[name='change_plan_phone_number"+index+"']").val();
	   
 
	   if(change_plan_from === undefined || change_plan_from == ""){
		 errorMsg += "Please choose change of plan for<br/>";        
	   }
	   
	   if(currentPlan === undefined || currentPlan == ""){
		 errorMsg += "Please choose current type of plan<br/>";        
	   }
 
	   if(phoneNumber === undefined || phoneNumber == ""){
		 errorMsg += "Please input the phone number";        
	   }
 
	   if(supplementary_plan === undefined || supplementary_plan == ""){
		 errorMsg += "Please choose the supplementary plan<br/>";        
	   }
 
	   if(supplementary_device_length >  0 && (supplementary_device === undefined || supplementary_device == "")){
		 errorMsg += "Please choose the supplementary device<br/>";        
	   }
 
	   if(errorMsg === ""){
		 eval("this.supplementaryType"+index+" = \"Change Plan\";");
		 eval("this.successSupplementary"+index+" = successMsg;");           
		 eval("this.errSupplementary"+index+" = \"\";");   
		 
		 eval("this.change_plan_from_"+index+" = change_plan_from;");     
		 eval("this.change_plan_currenTypePlan"+index+" = currentPlan;");    
		 eval("this.number"+index+" = phoneNumber;");    
	   }else{
		 eval("this.errSupplementary"+index+" = errorMsg;");        
		 eval("this.successSupplementary"+index+" = \"\";");    
		 eval("this.supplementaryType"+index+" = \"\";");                                        
	   }    
	   return;
	 }
	 eval("this.errSupplementary"+index+" = \"Please setup supplementary plan first\";"); 
       
    
  }

  checkSaveSupplementaryPlan(index){
    // $("[name='port_in_from_1']").val(1);
   var currentType = $("[name='planType"+index+"']:checked").val();    
   var supplementary_plan = $("[name='supplementary_plan"+index+"']").val(); 
   var supplementary_device = $("[name='supplementary_device"+index+"']").val(); 
   var supplementary_device_length = this['supplementaryPlan'+index].devices.length;
   eval("this.errSupplementary"+index+" = \"\";");        

   var saved = true;
   if(currentType == "New Line"){
     var phoneNumber =  $("[name='new_line_phone_number"+index+"']").val();      

     if(phoneNumber === undefined || phoneNumber == ""){
        saved = false;
     }
     
     if(supplementary_plan === undefined || supplementary_plan == ""){
        saved = false;       
     }

     if(supplementary_device_length >  0 && (supplementary_device === undefined || supplementary_device == "")){
        saved = false;       
     }     
     return saved;
   }
   if(currentType == "Port In"){
     var network = $("[name='port_in_network"+index+"']").val();
     var port_in_from = $("[name='port_in_from_"+index+"']").val();
     var phoneNumber =  $("[name='port_in_phone_number"+index+"']").val();      

     if(port_in_from === undefined || port_in_from == ""){
      saved = false;        
     }
     
     if(network === undefined || network == ""){
      saved = false;   
     }

     if(phoneNumber === undefined || phoneNumber == ""){
      saved = false;        
     }

     if(supplementary_plan === undefined || supplementary_plan == ""){
      saved = false;      
     }

     if(supplementary_device_length >  0 && (supplementary_device === undefined || supplementary_device == "")){
      saved = false;        
     }     
     return saved;
   }
   if(currentType == "Change Plan"){
     var change_plan_from = $("[name='change_plan_change_plan_from_"+index+"']").val();
     var currentPlan = $("[name='change_plan_currenTypePlan"+index+"']").val();
     var phoneNumber =  $("[name='change_plan_phone_number"+index+"']").val();
     

     if(change_plan_from === undefined || change_plan_from == ""){
      saved = false;          
     }
     
     if(currentPlan === undefined || currentPlan == ""){
      saved = false;          
     }

     if(phoneNumber === undefined || phoneNumber == ""){
      saved = false;          
     }

     if(supplementary_plan === undefined || supplementary_plan == ""){
      saved = false;         
     }

     if(supplementary_device_length >  0 && (supplementary_device === undefined || supplementary_device == "")){
      saved = false;           
     }
        
     return saved;
   }
   return false;
 }

  //new
  onChangeInputSearch(index) {
    this.isSearching = true;
    let request_number = this.textSearch;    
    let type = 1;    
    eval("type = this.supplementaryPlan"+index+".plan_category;");    
    this.getListPhone(request_number, type, index, true);
  }


  onClickCheckboxNumber(number, index){
    // check exist number ?
    // get old numberID 
    var oldID = this['phoneId'+index];    
    this['phoneId'+index] = number.id;
    this['number'+index] = number.attributes.phone_number;
    this['listPhoneNumber_Receive'+index].forEach(e => {
      e.selected = false;
    });
    
    // call update status new number
    // call update status old number ( release )

    if(this['phoneId'+index]){
      var requestUpdateStatusPhoneNumberSelecting = {
          number_id: number.id,
          status: 2
      };
      this.mainCampaignServices.updateStatusPhoneNumber(requestUpdateStatusPhoneNumberSelecting).subscribe(res => {
          if (res.success) {
              res.data.item.selected = true; 
              this.reloadPhoneList(index);             
          } else {
              if (confirm(res.error.description)) {
                let searchType = this["supplementaryPlan"+index].plan_category;    
                this.getListPhone('', searchType, index, true);
              }

          }

      });
    }

    if(oldID){
      var requestUpdateStatusPhoneNumberRollback = {
        number_id: oldID,
        status: 2
      };
      this.mainCampaignServices.updateStatusPhoneNumberRollback(requestUpdateStatusPhoneNumberRollback).subscribe(res => {
      });
    }
    number.selected = true;    	    
  }

  reloadPhoneList(index){
    for(var i=1;i<5;i++){
      
      if(i == index || this["enableSupplementary"+i] == undefined || this["enableSupplementary"+i] == false){
        continue;
      }
      if(this["supplementaryPlan"+i].id == this["supplementaryPlan"+index].id && this["enableNewLine"+i]){   
        let searchType = this["supplementaryPlan"+i].plan_category;   
        this.getListPhone('', searchType, i, true);
      }
    }
  }


  getListPhone(request_number, type, index, isReset: boolean = false) {
    let dataRequest = {
        phone: request_number,
        limit: 15,
        offset: this.listPhoneNumber_Receive.length,        
        campaign_id: this.globalService.getSession('id_campaign'),
        type: type, 
        index: index 
    };


    this.listPhoneNumberEndReached = false;

    if (isReset) {
        this.listPhoneNumber_Receive = [];
        this.listPhoneNumberEndReached = true;

        dataRequest.offset = 0;
    }

    this.mainCampaignServices.getListPhoneNumber(dataRequest).subscribe(res => {
        if (res.success) {
            this.isSearching = false;


            if (res.data.collection.length > 0) {
                this.listPhoneNumber_Receive = this.listPhoneNumber_Receive.concat(res.data.collection);

                if (this.listPhoneNumber_Receive.length < 15) {
                    this.listPhoneNumberEndReached = true;
                }

                // check when dont have step 1
                // this.listPhoneNumber_Receive.forEach(e => {
                //     e.selected = false;
                //     if (e.attributes.phone_number === request_number) {
                //         e.selected = true;
                //         this.idNumberSelect = e.id;
                //         this.globalService.setSession('phoneSelecting', e);

                //         this.form.get('phoneId').setValue(e.id);
                //         this.form.get('phoneId_number').setValue(e.attributes.phone_number);
                //     }
                // });         
                this['listPhoneNumber_Receive'+dataRequest.index]  = this.listPhoneNumber_Receive;
            } else {
                this.listPhoneNumberEndReached = true;
				this['listPhoneNumber_Receive'+dataRequest.index]  = [];
            }
        } else {
            // console.log('Error!');
        }


    });
    
  }

  getPhone(dataRequest) {
    this.mainCampaignServices.searchPhone(dataRequest).subscribe(res => {
        this.isSearching = false;
        if (res.success) {
            this.listPhoneNumber = res.data.map(res => {
                return {
                    number: res.phone_number,
                    selected: false
                };
            });
            return false;
        }
        this.listPhoneNumber = [];
    }, error => {
        this.listPhoneNumber = [];
        this.isSearching = false;
    });
  }

  onScroll() {
    // this.getListPhone('',1);
  }

  somethingChangedOnSearchPhone(data) {
    if (!data) {
      console.log(data);
      // Tam hide
        // let dataRequest = {
        //     phone: '',
        //     limit: 15,
        //     offset: 0,
        //     campaign_id: this.globalService.getSession('id_campaign')
        // };

        // /**get list phone and search */
        // this.mainCampaignServices.getListPhoneNumber(dataRequest).subscribe(res => {
        //     if (res.success) {
        //         this.isSearching = false;
        //         this.listPhoneNumber_Receive = res.data.collection;

        //         var phoneProcessing = this.globalService.getSession('phoneSelecting');
        //         this.listPhoneNumber_Receive.forEach(e => {
        //             e.selected = false;
        //             if (e.attributes.phone_number === phoneProcessing.attributes.phone_number) {
        //                 e.selected = true;
        //             }
        //         });
        //     }
        // });
    }
  }


  toggleShow(index) {
    eval("this.enableSupplementary"+index+"=!this.enableSupplementary"+index+";");
    eval("this.supplementaryType"+index+" = null;");
  }

  getNetwork() {
    this.mainCampaignServices.getListNetwork().subscribe(res => {
      this.listNetwork = res.network;
    })
  }
}
